var _style, _path, _path2, _path3, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoshootPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640.4 500",
    style: {
      enableBackground: "new 0 0 640.4 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED5338;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.4,21.4h96.1V0H10.7C4.8,0,0,4.7,0,10.7v106.8h21.4V21.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640.4,382.5H619v96.1h-96.1V500h106.8c5.9,0,10.7-4.8,10.7-10.7V382.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,500h106.8v-21.4H21.4v-96.1H0v106.8C0,495.2,4.8,500,10.7,500z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.9,86.2l-13.2,53h-85.2c-25.5,0-46.2,20.7-46.2,46.2v203.2c0,25.5,20.7,46.2,46.2,46.2h369.6 c25.5,0,46.2-20.7,46.2-46.2V185.3c0-25.5-20.7-46.2-46.2-46.2h-85.2l-13.2-53c-3-12.4-14.1-21-26.9-21h-119 C248,65.2,236.9,73.8,233.9,86.2L233.9,86.2z M388.6,90.7l15,60c1,4.1,4.7,7,9,7h92.4c15.3,0,27.7,12.4,27.7,27.7v203.2 c0,15.3-12.4,27.7-27.7,27.7H135.4c-15.3,0-27.7-12.4-27.7-27.7V185.3c0-15.3,12.4-27.7,27.7-27.7h92.4c4.3,0,7.9-2.9,9-7l15-60 c1-4.2,4.7-7,9-7h118.9C383.9,83.6,387.6,86.5,388.6,90.7L388.6,90.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.3,287c0,61.1,49.7,110.9,110.9,110.9S431.1,348.2,431.1,287s-49.7-110.9-110.9-110.9 S209.3,225.8,209.3,287z M320.2,194.5c51,0,92.4,41.5,92.4,92.4s-41.5,92.4-92.4,92.4s-92.4-41.5-92.4-92.4 S269.3,194.5,320.2,194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.2,360.8c40.8,0,73.9-33.1,73.9-73.9s-33.1-73.9-73.9-73.9s-73.9,33.1-73.9,73.9S279.4,360.8,320.2,360.8 z M320.2,231.5c30.5,0,55.5,24.9,55.5,55.5s-24.9,55.5-55.5,55.5s-55.5-24.9-55.5-55.5S289.7,231.5,320.2,231.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.2,177.4h-45.4c-5,0-9.1,4.1-9.1,9.1v45.4c0,5,4.1,9.1,9.1,9.1h45.4c5,0,9.1-4.1,9.1-9.1v-45.4 C193.2,181.5,189.2,177.4,184.2,177.4z M175.2,222.8h-27.2v-27.2h27.2C175.2,195.6,175.2,222.8,175.2,222.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M633.4,42.1c-15.5,0-28.1-12.6-28.1-28.1c0-3.9-3.2-7-7-7s-7,3.2-7,7c0,15.5-12.6,28.1-28.1,28.1 c-3.9,0-7,3.2-7,7s3.2,7,7,7c15.5,0,28.1,12.6,28.1,28.1c0,3.9,3.2,7,7,7s7-3.2,7-7c0-15.5,12.6-28.1,28.1-28.1c3.9,0,7-3.2,7-7 S637.2,42.1,633.4,42.1z M598.3,60.9c-3.1-4.7-7.2-8.7-11.8-11.8c4.7-3.1,8.7-7.2,11.8-11.8c3.1,4.7,7.2,8.7,11.8,11.8 C605.5,52.2,601.5,56.2,598.3,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.1,91.3c0,3.9,3.2,7,7,7c15.5,0,28.1,12.6,28.1,28.1c0,3.9,3.2,7,7,7s7-3.2,7-7 c0-15.5,12.6-28.1,28.1-28.1c3.9,0,7-3.2,7-7c0-3.9-3.2-7-7-7c-15.5,0-28.1-12.6-28.1-28.1c0-3.9-3.2-7-7-7s-7,3.2-7,7 c0,15.5-12.6,28.1-28.1,28.1C496.2,84.2,493.1,87.3,493.1,91.3z M535.2,79.4c3.1,4.7,7.2,8.7,11.8,11.8c-4.7,3.1-8.7,7.2-11.8,11.8 c-3.1-4.7-7.2-8.7-11.8-11.8C528,88.1,532,84.1,535.2,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.1,35.1C491.6,35.1,479,22.5,479,7c0-3.9-3.2-7-7-7s-7,3.2-7,7c0,15.5-12.6,28.1-28.1,28.1 c-3.9,0-7,3.2-7,7s3.2,7,7,7c15.5,0,28.1,12.6,28.1,28.1c0,3.9,3.2,7,7,7s7-3.2,7-7c0-15.5,12.6-28.1,28.1-28.1c3.9,0,7-3.2,7-7 S511,35.1,507.1,35.1z M472,53.9c-3.1-4.7-7.2-8.7-11.8-11.8c4.7-3.1,8.7-7.2,11.8-11.8c3.1,4.7,7.2,8.7,11.8,11.8 C479.1,45.2,475.1,49.2,472,53.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshootPro);
export default __webpack_public_path__ + "static/media/photoshoot_pro.8f8420e51fa6eca395a132d111cde9c6.svg";
export { ForwardRef as ReactComponent };